import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const Pager = ({ pager, label = "elementi", testId = "pager" }) => {
  if (pager.pages <= 1) return null;
  const go = (event, number) => {
    pager.setPage(number);
    event.currentTarget.closest(".practice-table-wrap, .module-section, .practice-workspace")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const numbers = Array.from({ length: pager.pages }, (_, index) => index + 1)
    .filter(number => number === 1 || number === pager.pages || Math.abs(number - pager.page) <= 1);
  return <nav className="pager" data-testid={testId} aria-label={`Pagine ${label}`}>
    <span className="pager-info" data-testid={`${testId}-info`}>{pager.from}–{pager.to} di {pager.total} {label}</span>
    <div className="pager-controls">
      <button type="button" disabled={pager.page === 1} data-testid={`${testId}-prev`}
        onClick={event => go(event, pager.page - 1)}><ChevronLeft size={15} /></button>
      {numbers.map((number, index) => <React.Fragment key={number}>
        {index > 0 && number - numbers[index - 1] > 1 && <span className="pager-gap">…</span>}
        <button type="button" className={number === pager.page ? "on" : ""} data-testid={`${testId}-page-${number}`}
          onClick={event => go(event, number)}>{number}</button>
      </React.Fragment>)}
      <button type="button" disabled={pager.page === pager.pages} data-testid={`${testId}-next`}
        onClick={event => go(event, pager.page + 1)}><ChevronRight size={15} /></button>
    </div>
  </nav>;
};
